<template>
  <div class="sku-list">
    <waterfall
      :data="skuList"
      :width="itemWidth"
    >
      <div
        :key="index + 'left'"
        class="sku-item"
        v-for="(sku, index) in skuList"
      >
        <goods-jump :sku="sku">
          <div class="sku-img">
            <img v-lazy="skuImg(sku.pic_url)" />
            <img
              v-if="borderImg"
              class="img-border"
              :src="borderImg"
              alt=""
            >
          </div>
          <div class="sku-intro">
            <div class="sku-name van-multi-ellipsis--l2">{{sku.name}}</div>
            <div class="sku-price">
              <div class="discount-price">
                <span class="sale-price">¥{{sku.activity | salePrice(sku.equity, sku.market_price)}}</span>
                <discount-price :sku="sku" />
              </div>
              <div
                class="normal-price"
                v-if='sku.activity.discount !== sku.market_price && sku.equity.discount !== sku.market_price'
              >
                <del>¥{{sku.market_price}}</del>
              </div>
            </div>
            <div class="sku-platform">
              <div class="platform-icon">
                <img v-lazy="sku.platform_info.logo" />
              </div>
              <div class="platform-name">{{sku.platform_info.brand}}</div>
            </div>
          </div>
        </goods-jump>
      </div>
    </waterfall>
  </div>
</template>

<script>
import GoodsJump from './GoodsJump'
import Waterfall from '../components/WaterFall'
import api from '../utils/api'
import DiscountPrice from '../components/DiscountPrice'
let flag = false
export default {
  name: 'goods-list',
  props: {
    skuList: {
      type: Array,
      require: true
    },
    borderImg: {
      type: String
    }
  },
  components: {
    GoodsJump,
    DiscountPrice,
    Waterfall
  },
  data () {
    return {
      columnWidth: (document.documentElement.clientWidth || document.body.clientWidth) / 750 * 345
    }
  },
  filters: {
    platform (p) {
      return require(`../assets/img/home-change/${p}.png`)
    },
    // 价格展示
    salePrice (activity, member, market) {
      if (activity) {
        return activity.discount
      } else if (member) {
        return member.discount
      } else {
        return market
      }
    }
  },
  computed: {
    itemWidth () {
      return this.columnWidth
    },
    skuImg (img) {
      return (img) => {
        if (img.includes('?')) {
          return `${img}&x-oss-process=image/resize,w_350`
        } else {
          return `${img}?x-oss-process=image/resize,w_350`
        }
      }
    }
  },
  created () {
    window.addEventListener('resize', this.resizeHandler, false)
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeHandler, false)
  },
  methods: {
    resizeHandler () {
      this.columnWidth = (document.documentElement.clientWidth || document.body.clientWidth) / 750 * 345
    },
    /**
     * 跳转商品详情
     * @param(String) id  商品skuid
     * @param(String) paltform 平台标识
     */
    async jumpDetails (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.sku-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.sku-item {
  margin-top: 0.2rem;
  width: 3.48rem;
  background-color: #fff;
  border-radius: 0.08rem;
  overflow: hidden;
  .sku-img {
    width: 3.48rem;
    position: relative;
    .img-border {
      width: 100%;
      height: 100%;
      object-fit: fill;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .sku-intro {
    padding: 0.1rem 0.15rem 0.2rem;
    .sku-name {
      margin: 0.1rem 0 0.2rem;
      color: #28292c;
      font-size: @fz24;
    }
    .discount-price {
      padding-bottom: 0.1rem;
      display: flex;
      align-items: center;
      font-size: @fz32;
      color: #ff5555;
      .sale-price {
        min-width: 1.3rem;
        padding-right: 0.1rem;
      }
    }
    .normal-price {
      padding: 0 0 0.2rem;
    }
    .normal-price,
    .sku-platform {
      color: #8d8f92;
      font-size: @fz26;
      display: flex;
      align-items: center;
      .platform-icon {
        width: 0.32rem;
        height: 0.32rem;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 0.05rem;
        img {
          object-fit: contain;
        }
      }
    }
  }
}
</style>
